<template>
  <section id="menu_emp">
    <ul>

        <router-link v-for="(link,index) in menu" :to="link.path" tag="li" :ref="link.name">
          <a>
          {{link.name}}
          </a>
        </router-link>
    </ul>
  </section>
</template>

<script>
  export default {
    name: 'menu-emp',
    data () {
      return {
        menu : menu
      }
    }}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// Chromless.vue?3116deee